<div>
  <span id="com-pr-orders-acct-num-cell" calltoaction
  [calltoactionTemplate]="comPrOrdersCashValuesAccountOverlay" [calltoactionUsesHover]="true" calltoactionPosition="right" calltoactionMaxWidth="500px" style="width:100%;">{{params?.valueFormatted}}</span>
</div>
<ng-template #comPrOrdersCashValuesAccountOverlay>
  <irb-com-pr-cash-values-account-overlay [row]="rebalAcctDto"></irb-com-pr-cash-values-account-overlay>
</ng-template>
